import { render, staticRenderFns } from "./BlockSlideshowHomepage.vue?vue&type=template&id=d5b6cef6&scoped=true&"
import script from "./BlockSlideshowHomepage.vue?vue&type=script&lang=js&"
export * from "./BlockSlideshowHomepage.vue?vue&type=script&lang=js&"
import style0 from "./BlockSlideshowHomepage.vue?vue&type=style&index=0&id=d5b6cef6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b6cef6",
  null
  
)

export default component.exports